// ------------------------------------------------------------------------------
// OperationResult
// author: mudas
// created: 2025/9/16
// ------------------------------------------------------------------------------

import React, { FC, ReactNode } from 'react';

import { Image, Typography } from '@fuxi/eevee-ui';

import SuccessImg from 'common/assets/image/success.webp';
import WarningImg from 'common/assets/image/fail.webp';
import FailImg from 'common/assets/image/warning.webp';

export interface IProps {
  status?: 'success' | 'fail' | 'warning';
  title?: ReactNode;
  description?: ReactNode;
  extra?: ReactNode;

  // 是否微调至适合移动端设备的外观
  isMobile?: boolean;
}

const OperationResult: FC<IProps> = (props) => {
  const { status = 'success', title, description, extra, isMobile = false } = props;

  return (
    <div className={`flex flex-col justify-center items-center gap-4 ${isMobile ? 'py-4' : 'py-6'}`}>
      <Image
        preview={false}
        width={isMobile ? 140 : 200}
        src={status === 'success' ? SuccessImg : status === 'fail' ? FailImg : WarningImg}
      />

      {title && (
        <Typography.Title level={isMobile ? 5 : 4} className={`${isMobile ? 'mt-4 text-center' : 'mt-6'}`}>
          {title}
        </Typography.Title>
      )}

      {description && (
        <Typography.Paragraph className={`text-color-secondary ${isMobile ? 'text-center' : ''}`}>
          {description}
        </Typography.Paragraph>
      )}
      {extra}
    </div>
  );
};

export default OperationResult;
